<template>
  <div id="if-wrapper">
    <div id="outer" v-if="showAnfaelleOverview">
      <div id="title-row" class="m-3">
        <h4>Erfasste Anfallstypen zum Patienten
        </h4>
      </div>
      <div id="new-anfall-button" class="px-4">
        <b-button variant="outline-primary" @click="startAddNewAnfall">Anfallstyp hinzufügen
          <b-icon-plus-circle/>
        </b-button>
      </div>
      <div id="table-row" class="m-4">
        <b-table show-empty striped bordered head-variant="light" :fields="anfaelleTableFields"
                 :items="anfaelleList">
          <template #empty="">
            {{ infoTextTableEmpty }}
          </template>
          <template #cell(idx)="data">
            {{ data.item.rule["IDX"] }}
          </template>
          <template #cell(type)="data">
            <div style="min-width: 500px">{{ data.item.rule['Anfallstyp'] }}</div>
          </template>
          <template #cell(extendedType)="data">
            <div style="min-width: 500px">{{ data.item.rule['Anfallstyp ausführlich'] }}</div>
          </template>
          <template #cell(date)="data">
            <b-form-input type="date" style="width: 200px" v-model="data.item.date"
                          v-on:input="dateChanged(data.item.date, data.index)" required
                          :state="validDate(data.item.date)"
                          aria-describedby="input-live-feedback" :min="patient.birthDate" :max="todayDate"/>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ infoTextNotValidDate }}
            </b-form-invalid-feedback>
          </template>
          <template #cell(buttons)="data">
            <b-button v-on:click="startEditAnfall(data.index)" class="mx-1" variant="outline-secondary">
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-on:click="showDeletionModal(data.index)" variant="outline-danger">
              <b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
    <template v-else>
      <FragebogenRoot @canceled="cancelAddNewAnfall" @finished="createNewAnfall"
                      :index-of-edited-anfall="indexOfEditedAnfall"></FragebogenRoot>
    </template>
    <DeletionModal :show="deletionModalDisplayed" :subheader-message="modalMessage"
                   :header-message="'Anfallstyperfassung wirklich abbrechen?'"
                   @close="closeDeletionModal"
                   @deleteConfirm="deleteAnfall"/>
  </div>
</template>

<script>
import FragebogenRoot from "./fragebogen/FragebogenRoot";
import {mapGetters, mapState} from "vuex";
import infoTexte from "../../../js/clinical-algorithm/infoTexte/infoTexte";
import DeletionModal from "../../modal/DeletionModal";
import {isoDateFormat, localDateFormat} from "../../../js/util";


export default {
  name: "AnfaelleRoot",
  components: {DeletionModal, FragebogenRoot},
  emits: {
    logout: null
  },
  data() {
    return {
      indexToBeDeleted: null,
      indexToEditDate: null,
      indexOfEditedAnfall: undefined,
      modalMessage: '',
      deletionModalDisplayed: false,
      showAnfaelleOverview: true,
      anfaelleTableFields: [
        {
          key: 'type',
          label: 'Anfallstyp'
        },
        {
          key: 'extendedType',
          label: 'Beschreibung'
        },
        {
          key: 'date',
          label: 'Erstmaliges Auftreten',
          thStyle: {width: '255px'}
        },
        {
          key: 'buttons',
          label: '',
          thStyle: {width: '150px'}
        }
      ],
      infoTextNotValidDate: ""
    }
  },
  computed: {
    ...mapState('cdss/anfallsanamnese', {
          anfaelleList: state => {
            let anfaelleList = []
            if (state && state.anfaelle) {
              state.anfaelle.forEach(anfall => {
                anfaelleList.push({
                  rule: anfall.rowsUsed[anfall.rowsUsed.length - 1],
                  date: isoDateFormat(new Date(anfall.datum))
                })
              })
            }
            return anfaelleList
          }
        }
    ),
    ...mapGetters('cdss', [
      'patientId', 'patient'
    ]),
    infoTextTableEmpty: () => infoTexte.anfallsanamneseInstructionIfStillEmpty,
    todayDate() {
      return isoDateFormat(new Date())
    }
  },
  methods: {
    showDeletionModal(index) {
      this.indexToBeDeleted = index;
      let anfalleElement = this.anfaelleList[this.indexToBeDeleted];
      let date = new Date(anfalleElement.date)
      this.modalMessage = "Eintrag vom " + localDateFormat(date) + " wirklich löschen?";
      this.deletionModalDisplayed = true;
    },
    closeDeletionModal() {
      this.indexToBeDeleted = null;
      this.deletionModalDisplayed = false;
    },
    startAddNewAnfall() {
      this.indexOfEditedAnfall = undefined
      this.$store.commit('cdss/setShowSavedDataFlag', false)
      this.showAnfaelleOverview = false;
      this.$store.commit('cdss/setShowAnfaelleOverview', false)
    },
    cancelAddNewAnfall() {
      this.$store.commit('cdss/setShowSavedDataFlag', true)
      this.showAnfaelleOverview = true;
      this.$store.commit('cdss/setShowAnfaelleOverview', true)
    },
    createNewAnfall(anfall) {
      if (this.indexOfEditedAnfall === undefined) {
        this.$store.commit('cdss/anfallsanamnese/pushAnfallToAnfaelleList', anfall)
      } else {
        this.$store.commit('cdss/anfallsanamnese/changeAnfallByIndex', {
          index: this.indexOfEditedAnfall,
          anfall: anfall
        })
      }

      this.$store.commit('cdss/setShowSavedDataFlag', true)
      this.showAnfaelleOverview = true
      this.$store.commit('cdss/setShowAnfaelleOverview', true)

    },
    deleteAnfall() {
      this.$store.commit('cdss/anfallsanamnese/deleteAnfall', this.indexToBeDeleted)
      this.closeDeletionModal()
    },
    dateChanged(date, index) {
      if (date !== "" && this.validDate(date) === null) {
        this.$store.commit("cdss/anfallsanamnese/changeDateOfAnfall", {date: new Date(date), index: index})
      }
    },
    validDate(date) {
      const pattern = /^\d{4}-\d{2}-\d{2}$/;
      if (!pattern.test(date)) {
        this.infoTextNotValidDate = infoTexte.notValidDate
        return false
      } else if (new Date(date) > new Date()) {
        this.infoTextNotValidDate = infoTexte.dateInTheFuture
        return false
      } else if (new Date(date) < new Date(this.patient.birthDate)) {
        this.infoTextNotValidDate = infoTexte.dateBeforeBirth
        return false
      } else
        return null
    },
    startEditAnfall(index) {
      this.indexOfEditedAnfall = index
      this.$store.commit('cdss/setShowSavedDataFlag', false)
      this.showAnfaelleOverview = false;
      this.$store.commit('cdss/setShowAnfaelleOverview', false)
    },
  }
}
</script>

<style scoped>
#if-wrapper {
  height: 100%;
  background-color: white;
}

#outer {
  display: grid;
  grid-template-areas: "title" "button" "anfaelle-table";
  grid-template-columns: 1fr;
  grid-template-rows: 50px 20px 1fr;
  height: 100%;
}

#title-row {
  grid-area: title;
}

#table-row {
  grid-area: anfaelle-table;
}

#new-anfall-button {
  grid-area: button;
  justify-self: right;
}
</style>
